import React, { useCallback, useEffect, useState } from 'react';
import tradeHistoryData from '../assets/tradeHistoryData';
import Loader from '../lib/components/Loader';

import constants from '../lib/constants';

import _debounce from 'lodash/debounce';

import api from '../utils/api';

import './TradeHistory.css';
import moment from 'moment';

const TradeHistory = () => {

    const [tradeList, updateTradeList] = useState([]);
    const [filteredTradeList, updateFilteredTradeList] = useState([]);
    const [isLoading, updateIsLoading] = useState(true);
    const [isError, updateIsError] = useState(false);

    const [randomManager, updateRandomManagerName] = useState(constants.managerList[0]);

    const [managerSearchCriteria, updateManagerSearchCriteria] = useState('');
    const [assetSearchCriteria, updateAssetSearchCriteria] = useState('');

    useEffect(() => {
        api.get('api/v1/tradeHistory').then(res => {
            updateTradeList(res.data.concat(tradeHistoryData));
            updateIsLoading(false);
        }).catch(res => {
            updateIsError(true);
            updateIsLoading(false);
            console.error('Error retrieving outgoing pick data: ' + res);
        });
        
        updateRandomManagerName(constants.managerList[Math.floor(Math.random() * 12)]);
    }, []);

    useEffect(() => {
        updateFilteredTradeList(tradeList);
    }, [tradeList]);

    const handleSearch = () => {
        if (managerSearchCriteria.length <= 0 && assetSearchCriteria.length <= 0) {
            return updateFilteredTradeList(tradeList);
        }
        let newTradeList = tradeList;
        if (managerSearchCriteria.length > 0) {
            const upperCaseManagerSearch = managerSearchCriteria.toUpperCase();
            // lets filter for managers first
            newTradeList = newTradeList.map(tradeSection => {
                return {
                    ...tradeSection,
                    trades: tradeSection.trades.filter(
                        trade => Object.keys(trade).find(
                            manager => manager.toUpperCase().includes(upperCaseManagerSearch)
                        )
                    )
                };
            });
        }
        
        if (assetSearchCriteria.length > 0) {
            const upperCaseAssetSearch = assetSearchCriteria.toUpperCase();
            // lets filter for assets now
            newTradeList = newTradeList.map(tradeSection => {
                return {
                    ...tradeSection,
                    trades: tradeSection.trades.filter(
                        trade => Object.values(trade).flat().find(
                            asset => String(asset).toUpperCase().includes(upperCaseAssetSearch)
                        )
                    )
                };
            });
        }
        updateFilteredTradeList(newTradeList);
    };

    useEffect(handleSearch, [managerSearchCriteria, assetSearchCriteria]);

    const handleSearchChangeManager = (e) => {
        updateManagerSearchCriteria(e.target.value);
    }

    const handleSearchChangeAsset = (e) => {
        updateAssetSearchCriteria(e.target.value);
    }
    
    return (
        <div id="TradeHistoryContainer">
            <h2>Trade History</h2>
            <small className="text-muted">Note: Trade history data still being gathered</small>
            <div>
                {isLoading ? <Loader/> : isError ? 'Something went wrong!' : <div>
                    <div className="tradeSearchContainer">
                        <form className="form-inline">
                            <select className="form-select" onChange={handleSearchChangeManager}>
                                <option value="">Any manager</option>
                                {constants.managerList.map(manager => (
                                    <option key={manager} value={manager}>{manager}</option>
                                ))}
                            </select>
                        </form>
                    </div>
                    <div className="tradeSearchContainer">
                        <form className="form-inline">
                            <input className="form-control" type="search" placeholder="Search by Asset" onChange={handleSearchChangeAsset}></input>
                        </form>
                        <small className="form-text text-muted">"{randomManager} 2022 2nd", "Joe Mixon"</small>
                    </div>
                    {filteredTradeList.map(tradeHistoryElement => {
                        return (
                            <div key={tradeHistoryElement.name}>
                                <h3>{tradeHistoryElement.name}</h3>
                                <div className="tradeSection">
                                    {tradeHistoryElement.trades.reverse().map((trade, index) => {
                                        return (
                                            <div key={index + 'trade'} className="trade">
                                                <div>{trade.time ? <b>{moment(trade.time).format('MM/DD/YY hh:mma')}</b> : 'Time not recorded'}</div>
                                                {Object.keys(trade).filter((k) => k !== 'time').map((tradeReciever, jndex) => { // sojanky
                                                    return(
                                                        <div key={index + jndex}><b>{tradeReciever}</b> recieves: {trade[tradeReciever].join(', ')}</div>
                                                    )
                                                })}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div> 
                }
            </div>
        </div>
    );
}

export default TradeHistory;